import BaseStore from '@src/utils/store/base-store';
import useMount from '@src/utils/hooks/use-mount';
import { observable } from 'mobx';
import BaseSwiperStore from '@src/components/swiper/base-swiper/store';
import { swiperOptions } from '@src/components/swiper/base-swiper/swiper-options';

let _this = null;
let _swiperFeature = null;
class FeatureStore extends BaseStore {
  mainBaseSwiperStore = new BaseSwiperStore({
    swiperOptions: {
      autoplay: false,
      pagination: {
        el: '#swiper-pagination',
        clickable: true
      },
      observer: true, //修改swiper自己或子元素时，自动初始化swiper
      observeParents: true, //修改swiper的父元素时，自动初始化swiper
      ...swiperOptions.getCustomizeSpecialShaped({
        autoplay: false,
        loopedSlides: 5,
        deviation: 64.8,
        customOn: {
          init: function(swiper) {
            _swiperFeature = this;
          },
          slideChangeTransitionStart: function() {
            _this.currentFeatureIndex = this.realIndex;
          }
        }
      })
    }
  });

  @observable currentFeatureIndex = 0;
  @observable featureData = [];

  slideFeature(type, event) {
    event.stopPropagation();
    if (type === 'prev') {
      _swiperFeature.slidePrev();
    } else if (type === 'next') {
      _swiperFeature.slideNext();
    }
  }

  updateSwiper = () => {
    _swiperFeature.update();
  };

  use() {
    super.use();
    _this = this;

    useMount(async () => {});
  }
}

export default FeatureStore;
